import React from "react";

import { Snackbar as MUISnackbar, SnackbarContent } from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";

import logo from "../../images/Logo.svg";
import Close from "@material-ui/icons/Close";

const styles = theme => ({
  root: {},
  content: {
    backgroundColor: "#fffafa",
    padding: 0,
    width: 360
  },
  muiMessage: {
    padding: 0
  },
  message: {
    display: "flex",
    flexDirection: "row",
    padding: [[12, 16, 12, 12]],
    alignItems: "center",
    backgroundColor: "#303030",
    borderRadius: [[4, 4, 0, 0]],
    position: "relative"
  },
  logo: {
    width: 22,
    marginRight: 4
  },
  text: {
    padding: 8,
    color: "white",
    fontSize: "0.875rem"
  },
  closeBtn: {
    fontSize: 16,
    cursor: "pointer",
    position: "absolute",
    top: "12px",
    right: "12px",
    "&:hover": {
      opacity: 0.9
    }
  }
});

let InfoSnack = ({ classes, open, onClose, className, message }) => {
  return (
    <MUISnackbar
      classes={{ root: classes.root }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right"
      }}
      open={open}
      onClose={onClose}
    >
      <SnackbarContent
        classes={{ root: classes.content, message: classes.muiMessage }}
        aria-describedby="alert-snackbar"
        message={
          <div className={classes.message}>
            <img src={logo} alt="Mondaybee Logo" className={classes.logo} />
            <p className={classes.text}>{message}</p>

            <Close className={classes.closeBtn} onClick={onClose} />
          </div>
        }
      />
    </MUISnackbar>
  );
};

export default withStyles(styles)(InfoSnack);



// WEBPACK FOOTER //
// ./src/components/Snackbar/InfoSnack.js